import { ReactNode } from 'react'
import logo from '@/assets/images/logo/sidebar-logo-light.png'
import background from '@/assets/images/background.jpg'


export default function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className='container relative grid h-svh flex-col items-center justify-center lg:max-w-none lg:grid-cols-2 lg:px-0'>
      <div
        className='relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex'
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}

      >
        <div className='absolute inset-0 bg-black/50' />
        <div className='relative z-20 flex items-center'>
          <img
            src={logo}
            width={200}
            alt='BuzMavi Logo'
          />

        </div>

        <div className='relative z-20 mt-auto'>
          <blockquote className='space-y-2'>
            <p className='text-lg'>
              &ldquo;Ateşten doğan gücü, kusursuz işçilik ve mühendislik disipliniyle geleceğe taşıyoruz.&rdquo;
            </p>
            <footer className='text-sm'>SAKA GROUP</footer>
          </blockquote>
        </div>
      </div>
      <div className='lg:p-8'>
        <div className='mx-auto flex w-full flex-col justify-center space-y-2 sm:w-[350px]'>
          {children}
        </div>
      </div>
    </div>
  )
}
